import React from 'react';
import { isMagicLinkError, MagicLinkErrorCode, useClerk } from '@clerk/clerk-react';
import { environmentContextState } from '../recoil/atoms';
import { useRecoilValue } from 'recoil';
import styles from './LoyaltyForm.module.scss';
import { CardBody } from '../components/CardBody';
import { CardFooter } from '../components/CardFooter';

const StatusContainer: React.FC = ({ children }) => (
  <div className={styles.statusContainer} style={{ paddingTop: 70 }}>
    {children}
  </div>
);

type VerificationStatus = 'loading' | 'failed' | 'verified' | 'expired';

const Content: React.FC<{ verificationStatus: VerificationStatus }> = ({ verificationStatus }) => {
  switch (verificationStatus) {
    case 'loading':
      return <StatusContainer>Loading...</StatusContainer>;
    case 'failed':
      return <StatusContainer>Magic link verification failed</StatusContainer>;
    case 'expired':
      return <StatusContainer>Magic link expired</StatusContainer>;
    default:
      return <StatusContainer>Successfully signed in. Return to the original tab to continue.</StatusContainer>;
  }
};

// Handle magic link verification results. This is
// the final step in the magic link flow.
const MagicLinkVerification: React.FC = () => {
  const [verificationStatus, setVerificationStatus] = React.useState<VerificationStatus>('loading');
  const environmentContext = useRecoilValue(environmentContextState);
  const { handleMagicLinkVerification } = useClerk();

  React.useEffect(() => {
    async function verify() {
      try {
        await handleMagicLinkVerification({
          redirectUrl: `https://${environmentContext.permanentDomain}/pages/profile`, // I don't know what this should be, original was redirect-to-pending-sign-in-like-2fa
          redirectUrlComplete: `https://${environmentContext.permanentDomain}/pages/profile`,
        });
        // If we're not redirected at this point, it means
        // that the flow has completed on another device.
        setVerificationStatus('verified');
      } catch (err) {
        // Verification has failed.
        let status: VerificationStatus = 'failed';
        if (isMagicLinkError(err) && err.code === MagicLinkErrorCode.Expired) {
          status = 'expired';
        }
        setVerificationStatus(status);
      }
    }
    verify();
  }, []);

  return (
    <>
      <CardBody>
        <Content verificationStatus={verificationStatus} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default MagicLinkVerification;
